import { render, staticRenderFns } from "./Kim.vue?vue&type=template&id=16ff5ecc&scoped=true"
import script from "./Kim.vue?vue&type=script&lang=js"
export * from "./Kim.vue?vue&type=script&lang=js"
import style0 from "./Kim.vue?vue&type=style&index=0&id=16ff5ecc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16ff5ecc",
  null
  
)

export default component.exports